import React, { useContext, useEffect, useRef, useState } from "react";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import { AuthContext } from "../../context/AuthContext";
import "./Home.css";
import MenuTop from "../../components/MenuTop/MenuTop";
import { DocumentTypeContext } from "../../context/DocumentContext";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import ContractUploadPanel from "../../components/ContractUploadPanel/ContractUploadPanel";
import { useNavigate } from "react-router-dom";
import Joyride, { STATUS, CallBackProps, Step } from "react-joyride";

const Home = () => {
  const { objUserTk } = useContext(AuthContext);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 650);
  const navigate = useNavigate();
  const {
    getDocumentSign,
    getSignersEdit,
    setDocument,
    setNameDocument,
    setIdEditDocument,
    getDocuments,
    tableDocuments,
    setCollaborators,
    tutorial,
    setTutorial,
  } = useContext(DocumentTypeContext);

  const [initDate, setInitDate] = useState<any[]>([]);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    var url = window.location.href;

    var urlObj = new URL(url);

    var documentId = urlObj.searchParams.get("documentId");

    const getDocument = async () => {
      if (documentId) {
        setIdEditDocument(documentId);
        await getDocumentSign(documentId);
        await getSignersEdit(documentId);
      }
      // else {
      //   setDocument(null);
      //   setNameDocument("");
      //   console.log("setCollaborators([]);2");
      //   setCollaborators([]);
      //   setIdEditDocument("");
      // }
    };
    getDocument();
  }, []);

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];

    if (file && file.type === "application/pdf") {
      try {
        setDocument(null);
        setNameDocument("");
        setCollaborators([]);
        setIdEditDocument("");

        const base64 = await toBase64(file);
        setDocument(base64);
        navigate("/admin/add-signatories");
        // navigate("/admin/create-documents");
      } catch (error) {
        console.error("Erro ao converter o arquivo para Base64:", error);
      }
    } else {
      alert("Por favor, selecione um arquivo PDF.");
    }
  };

  const toBase64 = (file: File): Promise<string> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });

  const steps: Step[] = [
    {
      target: ".icon-upload-document",
      content: "Clique aqui para iniciar o upload de um novo contrato!",
      placement: "right",
      disableBeacon: true,
    },
  ];

  const handleJoyrideCallback = (data: CallBackProps) => {
    const { status } = data;
    const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];
    //@ts-ignore
    if (finishedStatuses.includes(status)) {
      setTutorial(false);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 650);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const getData = async () => {
      await getDocuments(1);
    };
    getData();
  }, []);

  useEffect(() => {
    if (!isInitialized && tableDocuments.length > 0) {
      setInitDate(tableDocuments);
      setIsInitialized(true);
    }
  }, [tableDocuments, isInitialized]);

  return (
    <>
      <LoadingSpinner />

      <MenuTop />

      <Joyride
        steps={steps}
        run={tutorial}
        continuous
        showSkipButton
        showProgress
        callback={handleJoyrideCallback}
        locale={{
          last: "Finalizar",
        }}
        styles={{
          options: {
            zIndex: 10000,
            primaryColor: "#F9B233",
            textColor: "#333",
            arrowColor: "#fff",
            backgroundColor: "#fff",
          },
        }}
      />

      <div className="home-main-container">
        <div className="home-content">
          <div className="home-upload-section">
            <div className="home-upload-text">
              <h2 className="title-init-document">
                ASSINE UM NOVO CONTRATO
              </h2>
              <p className="title-init-document-2">
                CLIQUE NO BOTÃO E FAÇA O UPLOAD DO DOCUMENTO
              </p>
            </div>
            <label htmlFor="file-upload" className="icon-upload-document">
              <CloudUploadOutlinedIcon
                style={{ color: "#fff", cursor: "pointer" }}
              />
            </label>
            <input
              id="file-upload"
              type="file"
              accept="application/pdf"
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
          </div>

          <div className="home-contracts-section">
            <span className="contract-recent">CONTRATOS RECENTES</span>
            <div className="contracts-grid">
              {initDate.slice(0, 4).map((document: any, index: number) => (
                <div key={document.id || index} className="card-contract">
                  <div className="contract-preview">
                    <img
                      src={require("../../assets/img/theme/contractNewEndoc.png")}
                      alt="Contract"
                      style={{ width: "100%" }}
                    />
                  </div>
                  <span className="detalhes-document-recent">
                    {document.name}
                  </span>
                  <span className="detalhes-document-recent-2">
                    {document.status}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {!isMobileView && (
          <div className="home-sidebar">
            <ContractUploadPanel />
          </div>
        )}
      </div>
    </>
  );
};

export default Home;
